'use client';
import React, { useState, useEffect } from 'react';
import Homep from '@/app/componenets/Homep';
import Hero from '@/app/states/hero';
import AllState from '@/app/states/allstate';
import TawkTo from '../componenets/Tawko';
import Navbar from '@/app/componenets/Navbar';
import Footer from '@/app/componenets/Footer';
function page() {
  const [image, setImage] = useState('allstates');
  const [title, setTitle] = useState(' All States');
  const [subtitle, setSubtitle] = useState(
    'Premium Transportation Services Across'
  );
  return (
    <div>
      <TawkTo />
      <title>Professional Black Car Service across the States</title>
      <meta
        name="description"
        content="Get luxury black car services across all states with Prestige Ride. From City tours to Meeting and off-site events, book your ride for a smooth experience."
      />
      <meta name="robots" content="index, follow" />

      <meta
        name="keywords"
        content="
        Texas luxury black car service,
        Illinois premier car transportation,
        California upscale limousine rides,
        Massachusetts luxury ground transport,
        Connecticut professional chauffeur services,
        Florida top-tier black car service,
        New York exclusive airport transfers,
        New Jersey chauffeured rides,
        Pennsylvania premium point-to-point service,
        Georgia elegant city tours,
        Virginia smooth city-to-city rides,
        Maryland meetings and events transport,
        VIP client and partner travels,
        Upscale hourly hire in Texas,
        Special events in Illinois,
        Reliable chauffeur services in California,
        Point-to-point transport in Massachusetts,
        City tours in Connecticut,
        City-to-city rides in Florida,
        Meetings and offsite events in New York,
        Client and partner travels in New Jersey,
        Flexible hourly hire in Pennsylvania,
        Luxury special events in Georgia,
        Airport transfers in Virginia,
        Chauffeur services in Maryland,
        Point-to-point service in Washington, D.C.,
        City tours across Texas,
        City-to-city rides in Illinois,
        Meetings and events in California,
        Client and partner travels in Massachusetts,
        Hourly hire in Connecticut with Prestige Ride,
        Special events in Florida,
        Reliable airport transfers in New York,
        Chauffeur services in New Jersey,
        Point-to-point transport in Pennsylvania,
        City tours in Georgia with style,
        City-to-city rides in Virginia,
        Meetings and events in Maryland,
        Client and partner travels in Washington, D.C.,
        Luxurious special events nationwide."
      />
      <link rel="canonical" href="https://www.prestigeride.com/states" />

      {/* <Hero /> */}
      <Navbar />
      <Homep image={image} title={title} subtitle={subtitle} />
      <AllState />
      <Footer />
      {/* <Cta/>
      <Whychose/>
      <Unrivaled/> */}
      {/* <Text/> */}
    </div>
  );
}

export default page;
